import { TaxServiceRegistrationType } from "../../types/commonTypes/taxServiceRegistrationType";

export const initialTaxServiceRegistrationState: TaxServiceRegistrationType = {
    taxService: "",
    taxVille: ""
}